module.exports = __webpack_public_path__ + "img/equal.549c341c.svg";